import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import LoginPage from './pages/LoginPage'
import ConsolePage from './pages/ConsolePage'

function App() {
  const { isAuthenticated, loadFromSession } = useAuthStore()

  useEffect(() => {
    // Cargar sesión al iniciar la app
    loadFromSession()
  }, [loadFromSession])

  return (
    <BrowserRouter>
      <Routes>
        <Route 
          path="/login" 
          element={isAuthenticated ? <Navigate to="/consola" replace /> : <LoginPage />} 
        />
        <Route 
          path="/consola" 
          element={isAuthenticated ? <ConsolePage /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/" 
          element={<Navigate to={isAuthenticated ? "/consola" : "/login"} replace />} 
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
